import PropTypes from 'prop-types';
import * as UserTypes from './user';
import * as LeadersTypes from './leaders';
import * as RouterTypes from './router';

const timestamp = PropTypes.shape({
  Valid: PropTypes.bool.isRequired,
  Time: PropTypes.string.isRequired,
});

const ui = PropTypes.shape({
  external_offset: PropTypes.shape({}),
  alerts: PropTypes.shape({}),
  leaders_chart: PropTypes.shape({}),
  display_location: PropTypes.string,
  alert_exists: PropTypes.bool,
  connect_to_api: PropTypes.bool,
  take_action: PropTypes.map,
  source: PropTypes.string,
  terms_and_conditions_url: PropTypes.string,
});
const auth = PropTypes.shape({
  data: PropTypes.shape({
    token: PropTypes.string,
    name: PropTypes.string,
    answers: PropTypes.shape({}),
    user_id: PropTypes.number,
  }),
  loading: PropTypes.bool,
  load_error: PropTypes.bool,
  received: PropTypes.bool,
  success: PropTypes.bool,
});

const LocationModes = PropTypes.arrayOf(PropTypes.number);

const LocationSuggestion = PropTypes.shape({
  description: PropTypes.string.isRequired,
  place_id: PropTypes.string.isRequired,
});

const LocationSuggestions = PropTypes.arrayOf(LocationSuggestion);

const I18n = PropTypes.shape({
  t: PropTypes.func.isRequired,
});

const Vehicle = PropTypes.shape({
  index: PropTypes.number.isRequired,
  annualDistance: PropTypes.string,
  defaultDistance: PropTypes.string.isRequired,
  fuelType: PropTypes.number.isRequired,
  fuelTypeDisplay: PropTypes.string.isRequired,
  fuelConsumptionUnit: PropTypes.string.isRequired,
  efficiency: PropTypes.number.isRequired,
  fuelEfficiencyUnit: PropTypes.string.isRequired,
});

const Vehicles = PropTypes.arrayOf(Vehicle);

const UserInput = PropTypes.shape({
  inputDisplay: PropTypes.string,
  input: PropTypes.number,
  defaultDisplay: PropTypes.string.isRequired,
  default: PropTypes.number.isRequired,
  ensured: PropTypes.number.isRequired,
  ensuredDisplay: PropTypes.string.isRequired,
});

const Savings = PropTypes.arrayOf(
  PropTypes.shape({
    key: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }),
);

const UnitsOptions = PropTypes.arrayOf(
  PropTypes.shape({
    value: PropTypes.number.isRequired,
    display: PropTypes.string.isRequired,
  }),
);

const WidgetWindow = PropTypes.shape({
  innerWidth: PropTypes.number.isRequired,
  innerHeight: PropTypes.number.isRequired,
  outerWidth: PropTypes.number.isRequired,
  outerHeight: PropTypes.number.isRequired,
  pageYOffset: PropTypes.number.isRequired,
  pageXOffset: PropTypes.number.isRequired,
});

const WidgetContainer = PropTypes.shape({
  offsetTop: PropTypes.number.isRequired,
});

const Toast = PropTypes.shape({
  message: PropTypes.string,
  style: PropTypes.string,
  title: PropTypes.string,
  on: PropTypes.bool.isRequired,
});

const UserPledges = PropTypes.objectOf(
  PropTypes.shape({
    status: PropTypes.string,
    savingsAnnualDollars: PropTypes.string,
    savingsAnnualCarbonTons: PropTypes.string,
    upfrontCost: PropTypes.string,
  }),
);

export default {
  LocationSuggestion,
  LocationSuggestions,
  LocationModes,
  timestamp,
  I18n,
  ui,
  auth,
  Vehicle,
  Vehicles,
  UserInput,
  Savings,
  UnitsOptions,
  WidgetContainer,
  WidgetWindow,
  Toast,
  UserPledges,
  ...LeadersTypes,
  ...UserTypes,
  ...RouterTypes,
};
